import React from 'react'
import Grid from '@material-ui/core/Grid'
import AutoComplete from './AutoComplete'

import Utils from 'EurestoFonction/Utils'

export default class extends React.Component {
    constructor(props) {
        super(props)
        console.log(props)
        this.state = {
            value: (props.value || []).slice(),
            update: false
        }
    }

    componentWillReceiveProps(props) {
        if (props.disabled === true && this.state.update === true) {
            this.setState({
                update: false
            })
        }
    }

    render() {
        return <Grid container spacing={0} style={Object.assign({margin: 0, padding: 0}, this.props.style || {})}
                     direction={'column'} justify={'center'} alignItems={'stretch'} wrap={'nowrap'}>
            <AutoComplete
                placeholder={this.props.placeholder}
                autoFocus={this.props.autoFocus}
                autoComplete={this.props.autoComplete}
                classes={this.props.classes}
                MenuProps={this.props.MenuProps || {}}
                menuMaxHeight={this.props.menuMaxHeight}
                inputProps={this.props.inputProps || {}}
                InputProps={this.props.InputProps || {}}
                className={this.props.className}
                inlineWidth={this.props.inlineWidth}
                inline={this.props.inline}
                disabled={this.props.disabled || ((this.props.options || []).filter(o => (this.props.value || []).indexOf(o.value) === -1)).length === 0}
                inputStyle={{paddingBottom: 0, ...(this.props.inputStyle || {})}}
                multiple={true}
                key={Utils.getRandomNumber()}
                onChange={this.handleAddRemoveOnList} data={''}
                options={(this.props.options || []).filter(o => (this.props.value || []).indexOf(o.value) === -1)}
                title={this.props.title}/>
            {((this.props.value || []).filter(val => (this.props.options || []).find(o => o.value === val) !== undefined) || []).length > 0 && this.multiBox((this.props.value || []).filter(val => (this.props.options || []).find(o => o.value === val) !== undefined))}
            {/*this.state.update &&
      <Title inline={this.props.inline} style={{paddingTop: 5}} title={this.props.titleSecond || this.props.title && (<span>{this.props.title} non affectés</span>)}>
        {this.multiBox(this.props.options.filter(o => (this.props.value || []).indexOf(o.value) === -1).map(o => o.value), 'options')}
      </Title>*/}
        </Grid>

    }

    handleAddRemoveOnList = (id, value, e) => {
        if (id !== undefined) {
            let list = this.props.value || []
            const pos = list.indexOf(id)
            if (pos === -1) {
                list.push(id)
            } else {
                list.splice(pos, 1)
            }
            this.props.onChange && this.props.onChange(list, this.props.name)
        }

    }

    multiBox = (list, type) => {
        return <div style={{
            margin: 0,
            padding: 0,
            maxHeight: 200,
            marginTop: -3,
            //minHeight: type === 'values' && 'auto',
            overflowY: list && list.length > 0 && 'auto' || 'hidden',
            //marginTop: type === 'options' && -10,
            border: '2px solid green',
            borderRadius: 5,
            marginBottom: 5,
            cursor: this.props.disabled && 'not-allowed' || 'pointer',
            textAlign: 'center',
            ...(this.props.inputStyle || {})
        }}>
            {
                list && list.length > 0 && list.map((id, i) => {
                    return this.box(id, i, type)
                }) || this.props.libelleEmpty || <i className={'fa fa-ban'}/>
            }
        </div>
    }

    box = (id, i, type) => {
        const option = (this.props.options || []).find(o => o.value === id) && (this.props.options || []).find(o => o.value === id)
        return <Grid container
                     key={i + '_' + id}
                     onClick={() => !this.props.disabled && this.handleAddRemoveOnList(id)}
                     style={{margin: 0, padding: 0}} spacing={0}>
            <Grid item xs={4} style={{margin: 0, padding: 0}}/>
            <Grid item xs={4} style={{margin: 0, padding: 0, borderTop: i > 0 && '.5px solid black', height: 1}}/>
            <Grid item xs={4} style={{margin: 0, padding: 0}}/>
            <Grid item xs={12} style={{margin: 0, padding: 0}}>
                {option.html || option.label}
            </Grid>
        </Grid>
    }
}



// WEBPACK FOOTER //
// ./app/Components/Multiple.js